import React, { Component } from 'react';
import { Modal, message, Button } from 'antd';
import { Message } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

class DelGroupDirShModalDialog extends Component {

    componentDidUpdate() {
        const {
            submitDelGroupDirShStatus,
        } = this.props;
        if (submitDelGroupDirShStatus === ACTION_STATUS.SUCCESS) {
            message.success('Delete Group DirSh succeeded');
            this.props.initSubmitDelGroupDirShActionStatus();
            this.props.resetDelGroupDirShModal();
            this.props.queryGroupDirSh();
        }
        if (submitDelGroupDirShStatus === ACTION_STATUS.ERROR) {
            this.props.initSubmitDelGroupDirShActionStatus();
        }
    }

    submitDelGroupDirSh = () => {
        const { id } = this.props.delGroupDirShModal.fields;
        this.props.submitDelGroupDirSh({ id });
    }

    render() {
        const { isOpened, respErrMsg } = this.props.delGroupDirShModal;
        const isSubmitLoading = this.props.submitDelGroupDirShStatus === ACTION_STATUS.LOGINING;

        return (
            <div>
                <Modal
                    title='Del Group DirSh'
                    centered
                    width={520}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetDelGroupDirShModal()}
                    footer={[
                        <Button key='Cancel' onClick={() => this.props.resetDelGroupDirShModal()}>
                            Cancel
                        </Button>,
                        <Button key='Submit' type='primary' loading={isSubmitLoading} onClick={this.submitDelGroupDirSh}>
                            Submit
                        </Button>,
                    ]}
                >
                    <div>Delete the selected Group DirSh record permanently.</div>
                    {!!respErrMsg &&
                        <Message negative style={{ marginTop: 16 }}>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{respErrMsg}</p>
                        </Message>
                    }
                </Modal>
            </div>
        );
    }
}

export default DelGroupDirShModalDialog;
